import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IS_LOAD, IS_SEARCH } from 'src/app/shared/models/load.models';
import { QcResponse } from 'src/app/shared/models/qcResponse.model';
import { EnvironmentFacadeService } from 'src/app/shared/services/environment.facade.service';
import { PaginatorFacadeService } from 'src/app/shared/services/paginator.facade.service';
import { CheckbooksTypesResponse } from '../models/search-checkbooks.model';
import { SearchCheckbooksFacadeService } from './search-checkbooks.facade.service';

@Injectable({ providedIn: 'root' })
export class SearchCheckbooksService {
  constructor(
    private http: HttpClient,
    private environmentFacade: EnvironmentFacadeService,
    private searchCheckbooksFacade: SearchCheckbooksFacadeService,
    private paginatorFacadeService: PaginatorFacadeService,
  ) {}

  getCheckbooksTypes(): Observable<CheckbooksTypesResponse[]> {
    const url = `${this.environmentFacade.getEnvironment()}/rest/v1/bookcoupongroups/types`;
    return this.http.get<CheckbooksTypesResponse[]>(url, {
      withCredentials: true,
      context: new HttpContext().set(IS_LOAD, true),
    });
  }

  countByFilterCheckbooks(): Observable<QcResponse> {
    const url = `${this.environmentFacade.getEnvironment()}/rest/v1/bookcoupongroups/countByFilter`;
    const body = {
      bookCouponCode: this.searchCheckbooksFacade.checkbookCode,
      given: this.searchCheckbooksFacade.givenStatus,
      givenDate: this.searchCheckbooksFacade.givenDateFormat,
      invoiceNumber: this.searchCheckbooksFacade.invoiceNumber,
      loyaltyCard: this.searchCheckbooksFacade.cardNumber,
      loyaltyMemberId: null,
      tableBookCouponTypeId: this.searchCheckbooksFacade.selectedTypeId,
    };

    return this.http.post<QcResponse>(url, body, {
      withCredentials: true,
      context: new HttpContext().set(IS_SEARCH, true),
    });
  }

  getCheckbooks(): Observable<QcResponse> {
    const selectedOrder =
      this.paginatorFacadeService.selectedOrder === 'Ascending' ? 'ASC' : 'DESC';

    const selectedSortField =
      this.paginatorFacadeService.selectedSortField === 'Given date' ? 'GIVENDATE' : 'CODE';

    const start = this.paginatorFacadeService.itemsNumber * this.paginatorFacadeService.pageIndex;

    const url = `${this.environmentFacade.getEnvironment()}/rest/v1/bookcoupongroups/findByFilter?start=${start}&pageSize=${
      this.paginatorFacadeService.itemsNumber
    }&sortField=${selectedSortField}&sortOrder=${selectedOrder}`;

    const body = {
      bookCouponCode: this.searchCheckbooksFacade.checkbookCode,
      given: this.searchCheckbooksFacade.givenStatus,
      givenDate: this.searchCheckbooksFacade.givenDateFormat,
      invoiceNumber: this.searchCheckbooksFacade.invoiceNumber,
      loyaltyCard: this.searchCheckbooksFacade.cardNumber,
      loyaltyMemberId: null,
      tableBookCouponTypeId: this.searchCheckbooksFacade.selectedTypeId,
    };

    return this.http.post<QcResponse>(url, body, {
      withCredentials: true,
      context: new HttpContext().set(IS_SEARCH, true),
    });
  }

  getCouponSet(): Observable<QcResponse> {
    const url = `${this.environmentFacade.getEnvironment()}/rest/v1/couponset/search-dropdown`;

    return this.http.get<QcResponse>(url, {
      withCredentials: true,
      context: new HttpContext().set(IS_LOAD, true),
    });
  }
}
